<template>
  <div class="groessentabelle">
    <h2>{{ $t("konf_sizesTable") }}</h2>
    <div v-if="tableData!==null">
      <div class="product-size-switcher">
        <span class="product-size-zoll">{{ $t("showSizeValuesIn_inches") }}</span>
        <input class="container_toggle" :checked="isUnitInCM" type="checkbox" id="switch" name="mode" @change="changeUnit">
        <label for="switch">Toggle</label>
        <span class="product-size-cm">{{ $t("showSizeValuesIn_cm") }}</span>
      </div>
      <div class="table-wrapper">
        <div class="table-scroll">
          <table class="view-size-table">
            <tr v-for="zeile in tableData.zeilen" :key="zeile.description"
                :class="zeile.massEinheit + '-' + unitClass"
            >
              <td class="row_description">{{zeile.description}}</td>
              <td v-for="(cell, index) in zeile.zellen" :key="index" :colspan="cell.columnSpan">{{cell.value}}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div v-else>
      {{$t('groessenTabelle_contentHeaderDescriptionOneSizeFitsAll')}}
    </div>
  </div>
</template>

<script lang="ts">

import {onMounted, ref} from "vue";
import type {Ref} from "vue";
import {sendPostRequest} from "@k/global/axiosFormWrapper";
import type {GroessenTabelle} from "@k/js/databaseInterfaceClasses";
import {useShopInfos} from "~/store/shopInfosStore";


function loadSizeTable(land:string, sprache:string, auwiProdukt) {
  return new Promise<GroessenTabelle>(resolve=>{
    sendPostRequest("/konfigurator_php/global/getGroessenTabellenDaten.php", {auwiProdukt, land, sprache}).then(response=>resolve(response.data))
  });

}

export default {
  name: "ProductViewSizeTable",
  props: {
    produkt: String,
    sport: String
  },
  setup(props) {
    const tableData = ref(null) as Ref<null|GroessenTabelle>;

    const unitClass = ref('cm') as Ref<"cm"|"zoll">;
    const isUnitInCM = ref(true);
    const shopInfos = useShopInfos();
    onMounted(()=> {
      loadSizeTable(shopInfos.getDomainLand, shopInfos.getDomainSprache, props.produkt).then(function (table) {
        tableData.value = table;
        unitClass.value = (table.defaultMassEinheit === 'cm') ? 'cm' : 'zoll';
        isUnitInCM.value = unitClass.value === 'cm';
      })
    });

    function changeUnit() {
      unitClass.value = (unitClass.value === 'cm'  ? "zoll" : "cm")
    }

    return {
      changeUnit,
      tableData,
      unitClass,
      isUnitInCM
    }
  }
}
</script>

<style lang="scss" scoped>
.groessentabelle {
  margin-bottom: 80px;
  padding: 20px;
}

.table-wrapper {
  width: 100%;
  position: relative;
  overflow: hidden;
}

.table-scroll {

  @media (max-width: 820px) {
    overflow-x: scroll;
  }
}

.view-size-table {
  border-spacing: 0;
  margin-bottom: 40px;
  font-size: 11px;
  border: 1px solid #333;

  tr {
    &:nth-child(1) {
       background: $color-blue;
       color: $color-white;
     }

    td {
      padding: 10px 8px;
      border-left: 1px solid #333;
      border-top: 1px solid #333;
      text-align: center;

      &:first-child {
        border-left: none;
        text-align: left;
      }
    }
  }
}

.cm-cm { display: table-row; }
.cm-zoll { display: none; }
.inches-cm { display: none; }
.inches-zoll { display: table-row; }

input[type=checkbox] {
  height: 0;
  width: 0;
  visibility: hidden;
}

label {
  cursor: pointer;
  text-indent: -9999px;
  width: 55px;
  height: 30px;
  background: #333;
  display: flex;
  justify-content: center;
  align-items: center;
  -webkit-border-radius: 100px;
  -moz-border-radius: 100px;
  border-radius: 100px;
  position: relative;
  margin-left: 50px;
}

label:after {
  content: '';
  background: #fff;
  width: 20px;
  height: 20px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  position: absolute;
  top: 5px;
  left: 4px;
  transition: cubic-bezier(0.68, -0.55, 0.27, 01.55) 320ms;
}

input:checked + label {
  background: #333;
}

input:checked + label:after {
  left: calc(100% - 5px);
  -webkit-transform: translateX(-100%);
  -moz-transform: translateX(-100%);
  -ms-transform: translateX(-100%);
  -o-transform: translateX(-100%);
  transform: translateX(-100%);
}

.product-size-switcher {
  position: relative;
  width: 150px;
  margin-bottom: 20px;

  .product-size-zoll,
  .product-size-cm {
    position: absolute;
    left: 0;
    top: 25px;
    font-size: 16px;
    font-weight: 600;
  }

  .product-size-cm {
    left: auto;
    right: 0;
  }
}
</style>
